const isWin = navigator.platform == "Win32";

export { isWin }